import { createFileRoute } from '@tanstack/react-router'
import CompanyDetails from '../components/company-details/CompanyDetails'

export const Route = createFileRoute('/_a/companies/$companyId/')({
  component: CompanyDetails,
})
